<template>
    <div class="flex flex-col h-auto min-h-screen max-h-screen w-full bg-green-90">
        <div class="w-full px-5 md:px-10 lg:px-32 xl:px-64 pt-4 pb-3 text-grey-700 text-3xl sm:text-4xl">
			<a @click="goBack" @keypress.enter="goBack" tabindex="0" class="cursor-pointer">
				<svg class="inline-block align-middle mr-1 -mt-1" width="30" height="30" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19.375 23.25L11.625 15.5L19.375 7.75" class="stroke-current" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</a>

			Change email
		</div>
		<div class="px-5 md:px-10 lg:px-32 xl:px-64 pt-1 pb-32 text-green-1000 text-xl overflow-x-hidden overflow-y-auto">
			<div v-if="error" class="mb-4 py-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-red-600 text-white text-xl font-body">
				{{ error }}
			</div>
			<div v-if="success" class="mb-4 py-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-green-800 text-white text-xl font-body">
				Click the link we sent to your new email address to update it
			</div>
			
			<div>
				<input @keypress.enter="save" class="block w-full font-sans rounded-none bg-transparent text-green-800 placeholder-green-600 border-8 border-solid border-grey-500 px-2 py-2 text-2xl" type="text" placeholder="Enter your new email address..." v-model="email" />
			</div>
			<p v-if="user.unverified_email" class="text-green-900 text-lg font-body leading-tight mt-2">Waiting to be verified: {{ user.unverified_email }}</p>
			<p class="text-grey-800 text-xl font-body leading-tight pt-4 mb-4">We need this to send you important updates regarding your account, and in case you ever forget your password. We will never share your email address with anyone.</p>
			<p class="text-grey-800 text-xl font-body leading-tight mb-10">Your email address will not be updated until you click the link we'll send to your new address. Until then, you must continue logging in with the previous email address.</p>
		</div>

		<a @click="save" @keypress.enter="save" tabindex="0" class="fixed bottom-0 left-0 w-full font-sans border-none bg-red-600 text-red-80 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
			UPDATE
		</a>
    </div>
</template>

<script>
import Storages from 'js-storage';
import axios from 'axios';

export default {
    name: 'SettingsEmail',
    path: '/settings/email',
	data() {
		return {
			success: false,
			error: '',
			email: '',
			storage: null,
			key: '',
			user: {
				id: 0,
				username: '',
				email: '',
				unverified_email: '',
				premium: false
			}
		}
	},
    created() {
        this.storage = Storages.localStorage;
		this.getCurrentUser();
    },
    methods: {
		goBack() {
			if (window.history.length == 1) {
				this.$router.replace("/settings");
				return;
			}
			
			this.$router.go(-1);
		},
		validateEmail(email) {
			var re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
			return re.test(email);
		},
		submitEmail(email) {
			var that = this;
			this.success = false;
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/update/email?email=' + email + '&key=' + that.key)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					if (data.response.taken == true) {
						that.error = "There is already an account with this email address. Try logging in?";
					} else {
						that.user.unverified_email = that.email;
						that.storage.set('authed_user', that.user);
						that.success = true;
					}
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;

					if (data.response == "Missing or invalid email") {
						that.error = "Please enter a valid email address";
					} else {
						that.error = data.response;
					}
				} else {
					that.error = "An unknown error has occured.";
				}
			});
		},
		save() {
			this.error = '';

			if (this.validateEmail(this.email)) {
				this.submitEmail(this.email);
			} else {
				this.error = "Please enter a valid email address";
			}
		},
		getCurrentUser() {
			this.key = this.storage.get('session_key');
			if (this.storage.isSet('authed_user')) {
				this.user = this.storage.get('authed_user');
				this.email = this.user.email;
			}
		}
    }
}
</script>